<template>
    <div class="page">

        <div class="page__header">
            <div class="page__info">
                <div class="page__title">Списание</div>
                <div class="page__desc">Укажите количество продукта и причину списания</div>
            </div>
        </div>

        <div class="page__content">
            <form v-if="writeOff !== null" class="form-group" method="POST" action="" @submit.prevent="update()">

                <label for="store_id">Магазин</label>
                <div class="control-group">
                    <select
                            v-model="writeOff.store_id"
                            id="store_id"
                            class="form-control"
                            required
                            disabled>
                        <option
                                :value="store.id">{{ store.address }}</option>
                    </select>
                </div>
                <br>

                <label for="product_id">Продукт</label>
                <div class="control-group">
                    <select
                            v-model="writeOff.product_id"
                            id="product_id"
                            class="form-control"
                            required
                            disabled>

                        <option
                                :value="product.id">{{ product.title }}</option>
                    </select>
                </div>
                <br>

                <!--<label for="expired_at">Срок годности</label>-->
                <!--<div class="control-group">-->
                    <!--<input-->
                            <!--v-model="expired_at"-->
                            <!--id="expired_at"-->
                            <!--type="datetime-local"-->
                            <!--class="form-control"-->
                            <!--required-->
                            <!--disabled>-->
                <!--</div>-->
                <!--<br>-->

                <label for="quantity">Списано</label>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="control-group">
                            <div class="input-group">
                                <input
                                        v-model="writeOff.quantity"
                                        :max="quantity_old + supply.quantity_actual"
                                        :placeholder="1"
                                        id="quantity"
                                        type="number"
                                        class="form-control">
                                <div v-if="product != null" class="input-group-append">
                                    <span class="input-group-text">{{ product.packaging_type }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="btn btn-light" disabled> / </button>
                    <div class="col-sm-2">
                        <div class="control-group">
                            <div class="input-group">
                                <input
                                        :value="quantity_old + supply.quantity_actual"
                                        type="number"
                                        class="form-control"
                                        disabled>
                                <div v-if="product != null" class="input-group-append">
                                    <span class="input-group-text">{{ product.packaging_type }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <label for="cause">Причина</label>
                <div class="control-group">
                    <select
                            v-model="writeOff.cause"
                            id="cause"
                            class="form-control"
                            required>

                        <option value="expire">Срок годности</option>
                        <option value="defect">Дефект</option>
                        <option value="other">Другое</option>
                    </select>
                </div>
                <br>

                <label for="comment">Комментарий</label>
                <div class="control-group">
                    <textarea
                            v-model="writeOff.comment"
                            id="comment"
                            class="form-control"></textarea>
                </div>
                <br>

                <input type="submit" class="btn btn-success btn-large" value="Сохранить">

            </form>
        </div>

    </div>
</template>


<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'StoreWriteOffsUpdate',
        data() {
            return {
                quantity_old: 0
            }
        },
        computed: {
            writeOff() {
                return this.$store.state.writeOffs.writeOff != null ? this.$store.state.writeOffs.writeOff.writeOff : null
            },
            expired_at: {
                get() {
                    return this.$store.state.writeOffs.writeOff != null ? this.$moment(this.$store.state.writeOffs.writeOff.writeOff.expired_at * 1000).format('YYYY-MM-DDTHH:mm') : null
                },
                set(newVal) {
                    this.$store.state.writeOffs.writeOff.writeOff.expired_at = this.$moment(newVal).unix()
                }
            },
            supply() {
                return this.$store.state.writeOffs.writeOff != null ? this.$store.state.writeOffs.writeOff.supply : null
            },
            store() {
                return this.$store.state.writeOffs.writeOff != null ? this.$store.state.writeOffs.writeOff.store : null
            },
            product() {
                return this.$store.state.writeOffs.writeOff != null ? this.$store.state.writeOffs.writeOff.product : null
            },
        },
        methods: {
            ...mapActions([
                'storeStores',
                'storeWriteOffsGet',
                'storeWriteOffsUpdate',
            ]),
            async getStores() {
                await this.storeStores()
            },
            async getWriteOff() {
                await this.storeWriteOffsGet({
                    id: this.$route.params.id,
                })
            },
            async update() {
                await this.storeWriteOffsUpdate({
                    id: this.writeOff.id,
                    quantity: this.writeOff.quantity,
                    cause: this.writeOff.cause,
                    comment: this.writeOff.comment,
                })
            }
        },
        created() {
            this.getWriteOff();
            this.getStores();
        },
        watch: {
            writeOff: function (newVal, oldVal) {
                if (oldVal == null) {
                    this.quantity_old = newVal.quantity;
                }
            }
        }
    }
</script>